'use client';

/** Bagian 6 & 66 — Form login dengan pesan error yang ramah. */
import { useState } from 'react';
import { useRouter } from 'next/navigation';

export function LoginForm({
  demoEnabled, demoEmail,
}: { demoEnabled: boolean; demoEmail: string }) {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, remember }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error ?? 'Gagal masuk. Silakan coba lagi.');
        return;
      }
      router.replace(data.redirectTo ?? '/dashboard');
      router.refresh();
    } catch {
      setError('Tidak dapat menghubungi server. Periksa koneksi Anda.');
    } finally {
      setLoading(false);
    }
  }

  const fillDemo = () => {
    setEmail(demoEmail);
    setPassword('ChangeMe123!');
    setError(null);
  };

  return (
    <form onSubmit={submit}>
      {error && (
        <div className="rd-alert rd-alert-error" style={{ marginBottom: 14 }}>
          <div>{error}</div>
        </div>
      )}

      <div className="rd-field">
        <label className="rd-label" htmlFor="email">Email</label>
        <input
          id="email" type="email" className="rd-input" autoComplete="email"
          placeholder="nama@perusahaan.com" value={email}
          onChange={(e) => setEmail(e.target.value)} required autoFocus
        />
      </div>

      <div className="rd-field">
        <label className="rd-label" htmlFor="password">Password</label>
        <div style={{ position: 'relative' }}>
          <input
            id="password" type={showPassword ? 'text' : 'password'} className="rd-input"
            autoComplete="current-password" placeholder="••••••••"
            value={password} onChange={(e) => setPassword(e.target.value)}
            required style={{ paddingRight: 58 }}
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="rd-btn rd-btn-ghost rd-btn-sm"
            style={{ position: 'absolute', right: 4, top: 3, fontSize: 11 }}
          >
            {showPassword ? 'Sembunyi' : 'Lihat'}
          </button>
        </div>
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, marginBottom: 16, cursor: 'pointer' }}>
        <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
        Ingat saya selama 30 hari
      </label>

      <button
        type="submit"
        className="rd-btn rd-btn-primary"
        disabled={loading}
        style={{ width: '100%', justifyContent: 'center', padding: '9px 14px', fontSize: 13.5 }}
      >
        {loading ? 'Memproses…' : 'Masuk'}
      </button>

      {demoEnabled && demoEmail && (
        <div style={{
          marginTop: 18, padding: 11, background: 'var(--rd-info-light)',
          border: '1px solid #BFDBFE', borderRadius: 6, fontSize: 12,
        }}>
          <div style={{ fontWeight: 700, marginBottom: 3, color: '#1E40AF' }}>Akun Demo</div>
          <div style={{ color: '#1E40AF', marginBottom: 7 }}>
            {demoEmail} — untuk mencoba seluruh fitur.
          </div>
          <button type="button" className="rd-btn rd-btn-sm" onClick={fillDemo}>
            Isi otomatis
          </button>
        </div>
      )}
    </form>
  );
}
